import React, { useEffect } from 'react';
import { Heading, Subheading } from '../../components/Heading';
import { Card, CardBody } from '../../components/Card';
import { Avatar } from '../../components/Avatar';
import { Badge } from '../../components/Badge';
import { APP_VERSION, APP_COMMIT, APP_BUILT_AT } from '../../version';

const AboutPage: React.FC = () => {
    useEffect(() => {
        document.title = 'About';
    }, []);

    return (
        <>
            <Heading>About</Heading>

            <Card className="mt-6 p-5">
                <CardBody>
                    <div className="flex flex-wrap items-center gap-4">
                        <Avatar src="/images/GPCLogo2.png" className="size-16 shrink-0 bg-white" />
                        <div className="min-w-0">
                            <div className="text-lg font-semibold text-card-foreground">GPC Warehouse MS</div>
                            <p className="mt-1 text-sm text-muted-foreground">
                                Multi-warehouse inventory, orders, and mobile-fleet management console.
                            </p>
                        </div>
                    </div>
                    <div className="mt-5 grid gap-x-6 gap-y-4 border-t border-zinc-950/5 pt-5 dark:border-white/5 sm:grid-cols-3">
                        <div>
                            <div className="text-xs font-medium uppercase tracking-wide text-muted-foreground">Version</div>
                            <div className="mt-1 text-sm font-medium text-card-foreground">{APP_VERSION}</div>
                        </div>
                        <div>
                            <div className="text-xs font-medium uppercase tracking-wide text-muted-foreground">Build Commit</div>
                            <div className="mt-1 text-sm font-medium text-card-foreground">{APP_COMMIT}</div>
                        </div>
                        <div>
                            <div className="text-xs font-medium uppercase tracking-wide text-muted-foreground">Built</div>
                            <div className="mt-1 text-sm font-medium text-card-foreground">{new Date(APP_BUILT_AT).toLocaleString()}</div>
                        </div>
                    </div>
                </CardBody>
            </Card>

            <Card className="mt-6 p-5">
                <CardBody>
                    <Subheading>Platform</Subheading>
                    <p className="mt-2 text-sm leading-6 text-muted-foreground">
                        Manage multi-warehouse inventory end to end: stock in/out/adjust, stock balance transfers
                        between warehouses, sales orders, supplier/customer/logistics setup, SQL Account
                        integration/sync, audit logging, and mobile-app fleet management (salesman tracking,
                        pre/post call plans, announcements). A companion mobile app, SalesPilot GPC, serves
                        salesmen in the field.
                    </p>
                    <div className="mt-4 flex flex-wrap gap-2">
                        <Badge color="zinc">Inventory</Badge>
                        <Badge color="zinc">Tracking</Badge>
                        <Badge color="zinc">Reports</Badge>
                        <Badge color="zinc">SQL Account Sync</Badge>
                        <Badge color="zinc">AI Report Helper</Badge>
                        <Badge color="zinc">Mobile Fleet Management</Badge>
                    </div>
                </CardBody>
            </Card>

            <div className="mt-6 grid gap-6 sm:grid-cols-2">
                <Card className="p-5">
                    <CardBody>
                        <Subheading>Developer</Subheading>
                        <p className="mt-2 text-sm leading-6 text-muted-foreground">
                            Built and maintained by Doxa Stack Malaysia for Global Pharma Sdn. Bhd. and
                            Central Pharmacy Sdn. Bhd.
                        </p>
                    </CardBody>
                </Card>
                <Card className="p-5">
                    <CardBody>
                        <Subheading>License</Subheading>
                        <p className="mt-2 text-sm leading-6 text-muted-foreground">
                            Proprietary software. &copy;{new Date(APP_BUILT_AT).getFullYear()} Global Pharma
                            Management System. All rights reserved. This software may not be copied, modified,
                            or redistributed without written permission.
                        </p>
                        <div className="mt-3">
                            <div className="text-xs font-medium uppercase tracking-wide text-muted-foreground">License Key</div>
                            <div className="mt-1 font-mono text-sm font-medium text-card-foreground">
                                {process.env.REACT_APP_LICENSE_KEY || 'Not licensed'}
                            </div>
                        </div>
                    </CardBody>
                </Card>
            </div>
        </>
    );
};

export default AboutPage;
